<script setup>
// §8.6 AuditTrailRow (P1) — who / what / when / from → to. Universal audit is a
// product-wide principle. Records real events with real actors — including the
// approvals-off case where approved_by = self (§3.5.2): a real event, not a
// fabricated one. from → to renders as status chips when the change is a
// lifecycle transition.
import LStatusChip from '../status/StatusChip.vue'
import { STATUS } from '../status/statusMeta.js'

defineProps({
	who: { type: String, required: true },
	action: { type: String, required: true }, // what
	when: { type: String, required: true },
	from: { type: String, default: null }, // status value or plain text
	to: { type: String, default: null },
	self: { type: Boolean, default: false }, // approved_by = self
})
const isStatus = (v) => v && Object.prototype.hasOwnProperty.call(STATUS, v)
</script>

<template>
	<div class="l-audit">
		<div class="dot" aria-hidden="true"></div>
		<div class="content">
			<div class="line">
				<span class="who">{{ who }}</span>
				<span class="action">{{ action }}</span>
				<span v-if="self" class="self">· self-approved</span>
			</div>
			<div v-if="from || to" class="change">
				<template v-if="isStatus(from)">
					<LStatusChip :state="from" />
				</template>
				<span v-else-if="from" class="plain">{{ from }}</span>
				<span class="arrow" aria-hidden="true">→</span>
				<template v-if="isStatus(to)">
					<LStatusChip :state="to" />
				</template>
				<span v-else-if="to" class="plain">{{ to }}</span>
			</div>
		</div>
		<time class="when num">{{ when }}</time>
	</div>
</template>

<style scoped>
.l-audit
{
	display: grid;
	grid-template-columns: auto 1fr auto;
	gap: var(--sp-3);
	padding: var(--sp-3) 0;
	border-bottom: 1px solid var(--line-soft);
	align-items: start;
}

.l-audit:last-child
{
	border-bottom: 0;
}

.dot
{
	width: 7px;
	height: 7px;
	border-radius: 50%;
	background: var(--decorative);
	margin-top: 6px;
}

.line
{
	font-size: var(--text-base);
}

.who
{
	font-weight: 600;
	color: var(--text);
}

.action
{
	color: var(--text-2);
	margin-left: 4px;
}

.self
{
	color: var(--text-3);
	margin-left: 4px;
	font-size: var(--text-sm);
}

.change
{
	display: flex;
	align-items: center;
	gap: var(--sp-2);
	margin-top: 6px;
}

.arrow
{
	color: var(--decorative);
}

.plain
{
	font-size: var(--text-sm);
	color: var(--text-2);
}

.when
{
	font-size: var(--text-chip);
	color: var(--text-3);
	white-space: nowrap;
}
</style>
